<template>
  <div>
    <world-nav/>
    <b-card title="ステータス変換">
      <b-card-text>
        不奇跡世界でのステータスをどの程度反映するか指定します。
        閾値までは100%反映されます。閾値より上のステータスは弱体化します。<br>
        閾値0の場合、不奇跡世界でのステータスは反映されません。
      </b-card-text>
      <b-form-group v-for="(v, k) in innerValue.world.convertStatus" :key="k" 
        :id="'status'+k" :label="k">
        <b-row>
          <b-col cols="9"><b-form-input type="range" v-model="innerValue.world.convertStatus[k]" min="0" max="99" /></b-col>
          <b-col>＋{{v}}</b-col>
        </b-row>
      </b-form-group>
    </b-card>

    <b-button type="button" variant="primary" @click="$emit('submit')">登録</b-button>
    <response-message ref="response" :value="postMessage" />
  </div>
</template>

<script>
// import store from '@/store'
import WorldNav from '@/components/WorldNav'
import ResponseMessage from '@/components/ResponseMessage'
import mixinPlayer from './mixin-player'
export default {
  components: {
    WorldNav,
    ResponseMessage
  },
  mixins: [mixinPlayer],
  props: {
    value: Object,
    postMessage: Object,
  },
  data () {
    return {
      innerValue: this.value,
    }
  },
  methods: {
    setData () {
    }
  },
  mounted () {
  },
  watch: {
    innerValue (val) {
      this.$emit('input', val)      
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
